import tw, { styled } from 'twin.macro';

export const StyledSection = styled.section`
  ${tw`px-2 pb-7 pt-4 lg:pt-8 lg:pb-8`};
`;

export const StyledContainer = styled.div`
  ${tw`container`}
  ${tw`container-stack-context`}
`;

export const StyledGrid = styled.div<{ showSidebar: boolean }>`
  ${tw`flex flex-col lg:flex-row justify-center`};
  ${({ showSidebar }) => showSidebar && tw`lg:gap-[128px]`}
`;

export const StyledArticle = styled.article<{ showSidebar: boolean }>`
  ${tw`lg:w-[736px]`};
  ${({ showSidebar }) => showSidebar && tw`lg:w-[639px]`}

  .rich-text-inline-command > button {
    ${tw`w-full`}
  }
`;

export const StyledArticleWrapper = styled.div`
  ${tw`mt-4 lg:mt-0`};
`;

export const StyledSidebar = styled.aside<{ isInformationStripeVisible: boolean }>`
  ${tw`lg:w-[353px]`};
  ${tw`lg:h-[fit-content]`}
  ${tw`lg:sticky`}
  ${({ isInformationStripeVisible }) =>
    isInformationStripeVisible
      ? tw`lg:top-[160px]`
      : tw`lg:top-[128px]`}) // Top nav bar is 64px tall, or 104px with information stripe. We added 64px spacing between nav bar and sidebar.
`;

export const StyledComponentWrapper = styled.div<{
  hideOnDesktop?: boolean;
  showOnDesktop?: boolean;
}>`
  ${tw`block`};
  ${({ hideOnDesktop }) => hideOnDesktop && tw`lg:hidden`}
  ${({ showOnDesktop }) => showOnDesktop && tw`hidden lg:block`}
`;

export const StyledKeyResultsWrapper = styled.div`
  ${tw`px-2 py-4 md:p-6`}
  ${tw`mb-6`};
  ${tw`bg-ui-colours-ui1`}
  ${tw`rounded-xl`}
  & > * + * {
    margin-block-start: 32px;
    ${tw`before:content-['']`}
    ${tw`before:block before:w-full before:mb-4`}
    ${tw`before:border-b-2 before:border-secondary-s1`};
  }
`;

export const StyledCTAWrapper = styled.div`
  ${tw`mb-4`}
`;
